import { createFileRoute } from '@tanstack/react-router'

import { MonitoringPage } from '@/pages/MonitoringPage'

export const Route = createFileRoute('/_authenticated/monitoring')({
  component: MonitoringPage,
})
